import Immutable, { Record, List } from 'immutable';

import OverallDevelopmentSkill from './skills';
import { Unit } from 'data/Units';

const OverallDevelopmentTemplateRecord = Record({
  studentIDPId: undefined,
  studentId: undefined,
  units: new List(),
  strengths: new List(),
  improvementsModes: new List(),
  needAttentions: new List(),
});

class OverallDevelopmentTemplate extends OverallDevelopmentTemplateRecord { }

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'studentIDPId':
      return [key, `${val}`];
    case 'studentId':
      return [key, `${val}`];
    case 'units':
      return [key, new List(val.map(Unit.create))];
    case 'strengths':
      return [key, new List(val.map(OverallDevelopmentSkill.create))];
    case 'improvementsModes':
      return [key, new List(val.map(OverallDevelopmentSkill.create))];
    case 'needAttentions':
      return [key, new List(val.map(OverallDevelopmentSkill.create))];
    default:
      return [key, Immutable.fromJS(val)];
  }
};

OverallDevelopmentTemplate.create = (data) =>
  new OverallDevelopmentTemplate(data).mapEntries(reviver);

export default OverallDevelopmentTemplate;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/template/model.js